export class SearchCondition {
  user_name: string = ""
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  page: number = 1
  row_count: number =  100
}

export class UserResultViewableRange {
  id: number
  login_id: string
  user_name: string
  course_code: string
  campus_code: string
  class_code: string
  course_name: string
  campus_name: string
  class_name: string
  full_count: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id
    this.login_id = x.login_id
    this.user_name = x.user_name
    this.course_code = x.course_code
    this.campus_code = x.campus_code
    this.class_code = x.class_code
    this.course_name = x.course_name
    this.campus_name = x.campus_name
    this.class_name = x.class_name
    this.full_count = x.full_count
  }
}